module.exports = __webpack_public_path__ + "static/img/main6_6.99460940.png";